import { api, apiClientV2, unwrapV2Response } from './index.js';

/**
 * Fetch a job's status timeline (v2).
 * GET /jobs/{jobUuid}/timeline
 *
 * @param {string} jobUuid
 * @returns {Promise<{ job_uuid: string, job_status: string, status_messages: Array }>}
 */
export const getJobTimeline = async jobUuid => {
	const { data, error } = await apiClientV2.get(`/jobs/${jobUuid}/timeline`);
	if (error) throw error;
	return unwrapV2Response(data);
};

/**
 * Fetch the latest job for a project (v2). Used to resume the detection
 * progress card when returning to a project with a job still running.
 * GET /jobs/{projectUuid}/latest
 *
 * @param {string} projectUuid
 * @returns {Promise<{ job_uuid, job_type, job_status, status_messages, job_meta } | null>}
 */
export const getLatestJob = async projectUuid => {
	const { data, error } = await apiClientV2.get(`/jobs/${projectUuid}/latest`);
	if (error) throw error;
	return unwrapV2Response(data);
};

export const getModelsDetectedOn = async project_uuid => {
	const { data } = await api.get(`/jobs/models_detected_on/${project_uuid}`);
	return data;
};

export const getOngoingTrainingOrEvaluation = async model_uuid => {
	const { data } = await api.get(
		`/jobs/check_on_going_training_or_evaluation_for_model?model_uuid=${model_uuid}`
	);
	return data;
};
